import DataCollectionAdd from '../../shared/DataCollectionAdd.js';
import { useTranslation } from 'react-i18next';

const AddBreedForm = (props) => {
  const { t } = useTranslation();
  return (
    <>
      <input type="text" name="name"
        placeholder={t("breed")} required/>
      <input type="text" name="matches"
        placeholder={t("nicknames")} />
      <div>{t("nicknames_hint")}</div>
    </>
  );
}

const getBodyFromForm = (formData) => {
  const name = formData.get("name");
  const matches = `${name};${formData.get("matches")}`;
  return JSON.stringify({ name, matches });
}

export const AddBreed = (props) => {
  return (
    <DataCollectionAdd
      collection="breeds"
      getBodyFromForm={getBodyFromForm}
      formElements={AddBreedForm}
      onSuccess={props.onSuccess}
    />
  );
}

export default AddBreed;
